<template>
  <button
    v-if="canToggleFullWidth"
    type="button"
    class="dashboard-nav-action dashboard-nav-corner-toggle"
    @click="$emit('toggle-full-width')"
    :title="isFullWidth ? s__('Boards|Exit full width') : s__('Boards|Full width')"
  >
    <span class="dashboard-nav-icon dashboard-nav-corner-icon">{{ isFullWidth ? '⊟' : '⊞' }}</span>
    <span class="dashboard-nav-title">
      {{ isFullWidth ? s__('Boards|Exit full width') : s__('Boards|Full width') }}
    </span>
  </button>
  <button
    v-if="canCollapse"
    type="button"
    class="dashboard-nav-action dashboard-nav-corner-toggle dashboard-nav-collapse-toggle"
    @click="$emit('toggle-collapse')"
    :title="collapsed ? __('Expand') : __('Collapse')"
  >
    <span class="dashboard-nav-icon dashboard-nav-corner-icon">{{ collapsed ? '»' : '«' }}</span>
    <span class="dashboard-nav-title">{{ collapsed ? __('Expand') : __('Collapse') }}</span>
  </button>
</template>

<script setup>
import { __, s__ } from '@/locale'

defineProps({
  canToggleFullWidth: {
    type: Boolean,
    default: false,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  canCollapse: {
    type: Boolean,
    default: false,
  },
  collapsed: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['toggle-full-width', 'toggle-collapse'])
</script>
